import { PropsWithChildren } from "react";
import "./PageContent.scss";

const PageContent = ({ children, className }: PropsWithChildren<{ className?: string }>) => (
    <div className={`page-content ${className || ""}`}>{children}</div>
);

/**
 * Page Content Columns Component
 */
PageContent.Columns = function Columns({ children }: PropsWithChildren<{}>) {
    return <div className="page-content__columns">{children}</div>;
};

/**
 * Page Content Column Component
 */
PageContent.Column = function Column({ children }: PropsWithChildren<{}>) {
    return <div className="page-content__column">{children}</div>;
};

/**
 * Page Content Row Component
 */
PageContent.Row = function Row({ children }: PropsWithChildren<{}>) {
    return <div className="page-content__row">{children}</div>;
};

/**
 * Page Content Title
 */
PageContent.Title = function Row({ children }: PropsWithChildren<{}>) {
    return <div className="page-content__title">{children}</div>;
};

export default PageContent;
